import React, { useState } from "react";
import "./Accordion.css"; // 必要に応じてCSSファイルをインポート

/**
 * アコーディオンアイテムのプロパティ
 */
export interface AccordionItemProps {
  title: React.ReactNode;
  content: React.ReactNode;
}

/**
 * アコーディオンアイテム
 * @param {AccordionItemProps} props - アコーディオンアイテムのプロパティ
 * @param {React.ReactNode} props.title - アコーディオンアイテムのタイトル
 * @param {React.ReactNode} props.content - アコーディオンアイテムのコンテンツ
 * @returns {JSX.Element} アコーディオンアイテムのJSX要素
 */
const AccordionItem: React.FC<AccordionItemProps> = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  /**
   * アコーディオンを開閉する
   */
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="accordion-item">
      <dt
        className={`accordion-trigger ${isOpen ? "is-open" : "is-close"}`}
        onClick={toggleAccordion}
      >
        <div className="accordion-text">{title}</div>
      </dt>
      {isOpen && (
        <dd className="accordion-target">
          <div className="accordion-text">{content}</div>
        </dd>
      )}
    </div>
  );
};

/**
 * アコーディオンのプロパティ
 */
interface AccordionProps {
  items: AccordionItemProps[];
}

const Accordion: React.FC<AccordionProps> = ({ items }) => {
  return (
    <dl className="accordion">
      {items.map((item, index) => (
        <AccordionItem key={index} title={item.title} content={item.content} />
      ))}
    </dl>
  );
};

export default Accordion;
